import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';

const ARBusinessConfig = initConst<IBusinessConfigs>(() => ({
  ARTillgang: {
    defaultColumns: [
      { attributeDef: 'ANLAGGNINGS_NR', caption: 'Anläggn nr' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'AnskaffDatum', caption: 'Anskaff datum' },
      { attributeDef: 'Plats.OmradeKodBen', caption: 'Område' },
      { attributeDef: 'AnlKat.KodBen', caption: 'Kategori' },
      { attributeDef: 'Rubrik.KodBenamning', caption: 'Rubrik' },
      { attributeDef: 'ANLAGGNTILLG', caption: 'Anlägg.tillgång' },
      { attributeDef: 'Plats.ByggnadKodBen', caption: 'Byggnad' },
      { attributeDef: 'Plats.RumKodBen', caption: 'Rum' },
    ],
  },
  ARUpprakning: {
    defaultColumns: [
      { attributeDef: 'Tillgang.ANLAGGNINGS_NR', caption: 'Anl nr' },
      { attributeDef: 'Tillgang.BENAMNING', caption: 'Benämning' },
      { attributeDef: 'BENAMNING', caption: 'Text' },
      { attributeDef: 'DATUM', caption: 'Datum' },
      { attributeDef: 'InvBeloppPerDatum', caption: 'Anskaffn värde' },
      { attributeDef: 'RestVardePerDatum', caption: 'Restvärde' },
      { attributeDef: 'AretAvskrPerDatum', caption: 'Bokf avskrivn' },
      { attributeDef: 'AVSKRMAN', caption: 'Avskr tid (år)' },
      { attributeDef: 'AterstAvskrTidPerDatum', caption: 'Återst avskr tid' },
      { attributeDef: 'Tillgang.Plats.OmradeKodBen', caption: 'Område' },
      {
        attributeDef: 'Tillgang.AnlGrupp.BENAMNING',
        caption: 'Anläggningsgrupp',
      },
    ],
  },
  ARHuvudRubrik: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'ANLAGGNTILLG', caption: 'Anlägg.tillgång' },
      // { attributeDef: 'asdfawefwef', caption: 'Test' },
      // { attributeDef: 'ATGARDER', caption: 'Registrering av åtgärder' }, // TODO: fix this
    ],
  },
  ARRubrik: {
    defaultColumns: [
      { attributeDef: 'AR_RUBRIK_ID', caption: 'Kod' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'SKATTEMASSIG', caption: 'Skattemässig' },
    ],
  },
  ARAnlGrupp: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'Urvalsprincip', caption: '' },
    ],
  },
  ARPlats: {
    defaultColumns: [
      { attributeDef: 'Anlaggningsgrupp', caption: 'Anläggningsgrupp' },
      { attributeDef: 'PLATS_KOD', caption: 'Kod' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  ARAnlKat: {
    defaultColumns: [
      { attributeDef: 'AR_ANLKAT_ID', caption: 'Kod' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'LEDTEXT1', caption: 'Ledtext1' },
      { attributeDef: 'LEDTEXT2', caption: 'Ledtext2' },
      { attributeDef: 'LEDTEXT3', caption: 'Ledtext3' },
      { attributeDef: 'LEDTEXT4', caption: 'Ledtext4' },
      { attributeDef: 'LEDTEXT5', caption: 'Ledtext5' },
      { attributeDef: 'LEDTEXT6', caption: 'Ledtext6' },
      { attributeDef: 'LEDTEXT7', caption: 'Ledtext7' },
      { attributeDef: 'LEDTEXT8', caption: 'Ledtext8' },
      { attributeDef: 'NORMALAVSKRTID', caption: 'Normal avskr.tid' },
    ],
  },
  ARVerksamhetskod: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  ARAtgardskod: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'REG_BELOPP', caption: 'Belopp kan registreras' },
    ],
  },
  ARKomponent: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'AKTIV', caption: 'Aktiv' },
      { attributeDef: 'Standard', caption: 'Standard komponenttyp' },
    ],
  },
}));

export default ARBusinessConfig;
